import { render, staticRenderFns } from "./app-order.vue?vue&type=template&id=e08aaa06&scoped=true"
import script from "./app-order.vue?vue&type=script&lang=js"
export * from "./app-order.vue?vue&type=script&lang=js"
import style0 from "./app-order.vue?vue&type=style&index=0&id=e08aaa06&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08aaa06",
  null
  
)

export default component.exports